import { ReactNode } from 'react';
import { Typography, Box, Grid2 as Grid } from '@mui/material';
import { responsivePagePadding } from '../utils/constants';
import headerBack from '../../assets/media/headerholder.png';

function PageHeader({ text, imageSrc }: { text: ReactNode; imageSrc: string }) {
  const imageHeightResponsive = {
    xs: '340px',
    sm: '400px',
    md: '500px',
  };
  return (
    <Grid
      container
      spacing={4}
      alignItems="center"
      justifyContent="center"
      sx={{
        width: '100%',
        padding: responsivePagePadding,
      }}
    >
      <Grid size={{ xs: 12, sm: 7 }}>
        <Typography
          variant="h1"
          sx={{
            textAlign: { xs: 'center', md: 'left' }, // Center text on small screens
          }}
        >
          {text}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, sm: 5 }} sx={{ position: 'relative' }}>
        {/* Background Image */}
        <Box
          component="img"
          src={headerBack}
          alt="Hula Circle Background"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            maxWidth: '100%',
            height: 'auto',
            maxHeight: imageHeightResponsive,
            zIndex: 0,
          }}
        />
        {/* <img
          src={headerBack}
          alt="Hula Circle Background"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            maxWidth: '100%',
            height: 'auto',
            // maxHeight: {imageHeightResponsive},
            // objectFit: 'cover',
            zIndex: 0,
          }}
        /> */}
        {/* Foreground Image */}
        {/* <img
          src={imageSrc}
          alt="No image found"
          style={{
            position: 'relative',
            zIndex: 1,
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '500px',
          }}
        /> */}
        <Box
          component="img"
          src={imageSrc}
          alt="Page Header Image"
          sx={{
            position: 'relative',
            maxWidth: '100%',
            height: 'auto',
            maxHeight: imageHeightResponsive,
            zIndex: 1,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default PageHeader;
